import { BOOLEAN_SELECT_LIST_ITEMS, Stack, ValidationErrors, pn } from "@compass/core";
import { DatePicker, Select } from "components";
import { MatchReportActualYearlyFilter, MatchReportActualYearlyResource } from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";
import { MatchReportGlobalFilter } from "../MatchReportPage";

export const ActualYearlyFilter = (props: {
  filter: MatchReportActualYearlyFilter;
  setFilter: (value: MatchReportActualYearlyFilter) => void;
  globalFilter: MatchReportGlobalFilter;
  setGlobalFilter: (value: MatchReportGlobalFilter) => void;
  validationErrors: ValidationErrors;
}) => {
  const [resource, setResource] = useState<MatchReportActualYearlyResource>({});
  const properties = resource.filterProperties || [];

  useEffect(() => {
    fetchResource();
  }, []);

  useEffect(() => {
    props.setFilter(
      produce(props.filter, (draft) => {
        draft.isMatch = props.globalFilter.isMatch;
        draft.reviewId = props.globalFilter.reviewId;
      })
    );
  }, []);

  const fetchResource = () => {
    ApiService.matchReports.getActualYearlyResource().then((response) => {
      setResource(response);

      props.setFilter(
        produce(props.filter, (draft) => {
          if (response.defaultDateFrom) draft.dateFrom = response.defaultDateFrom;
          if (response.defaultDateTo) draft.dateTo = response.defaultDateTo;
        })
      );
    });
  };

  const dateFromField = () => {
    const propertyName = pn<MatchReportActualYearlyFilter>("dateFrom");
    const property = properties.find((x) => x.propertyName === propertyName);

    return <DatePicker modelProperty={property} disabled value={props.filter.dateFrom} />;
  }

  const dateToField = () => {
    const propertyName = pn<MatchReportActualYearlyFilter>("dateTo");
    const property = properties.find((x) => x.propertyName === propertyName);

    return <DatePicker modelProperty={property} disabled value={props.filter.dateTo} />;
  }

  const reviewField = () => {
    const propertyName = pn<MatchReportActualYearlyFilter>("reviewId");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={resource.matchReviews?.find((x) => x.id === props.filter.reviewId)}
        options={resource.matchReviews}
        getOptionLabel={option => option.name}
        onChange={(e, value) => {
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.reviewId = value?.id;
            })
          );
          props.setGlobalFilter(
            produce(props.globalFilter, (draft) => {
              draft.reviewId = value?.id;
            })
          );
        }}
      />
    );
  };

  const isMatchField = () => {
    const propertyName = pn<MatchReportActualYearlyFilter>("isMatch");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={BOOLEAN_SELECT_LIST_ITEMS.find((x) => x.id === props.filter.isMatch)}
        options={BOOLEAN_SELECT_LIST_ITEMS}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) => {
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.isMatch = value?.id;
            })
          );
          props.setGlobalFilter(
            produce(props.globalFilter, (draft) => {
              draft.isMatch = value?.id;
            })
          );
        }}
      />
    );
  };

  return (
    <Stack spacing="sm">
      {dateFromField()}
      {dateToField()}
      {reviewField()}
      {isMatchField()}
    </Stack>
  );
};
